import { render, staticRenderFns } from "./ModificarLaboratorio.vue?vue&type=template&id=9a6623f2"
import script from "./ModificarLaboratorio.vue?vue&type=script&lang=js"
export * from "./ModificarLaboratorio.vue?vue&type=script&lang=js"
import style0 from "./ModificarLaboratorio.vue?vue&type=style&index=0&id=9a6623f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports